import styled from 'styled-components';

import { breakPoints } from '~/src/constants/breakpoints';

import { GridContainer as GridContainerCommon } from '~/src/features/center/common/styled';

export const Wrapper = styled.div`
    width: 100%;
    background-color: transparent;
    padding: 0;
`;

export const GridContainer = styled(GridContainerCommon)`
    position: relative;
    margin-bottom: 0;
    background-color: transparent;
    padding-left: 0;
    padding-right: 0;
    z-index: 1;
    
    @media (max-width: ${breakPoints.mobile}) {
        margin-left: 16px;
        margin-right: 16px;
    }
`;
